import React from 'react'
import ReactDOM from 'react-dom/client'
import './asset/scss/custom.scss'
import '@fontsource/montserrat'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
// import configureStore from './redux/store'
// import { PersistGate } from 'redux-persist/integration/react'
// import { persistStore } from 'redux-persist'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'mdbreact/dist/css/mdb.css';
import 'react-toastify/dist/ReactToastify.css'
import store from './store';
// const store = configureStore()

// const persistor = persistStore(store)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter> 
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
